module.exports = __webpack_public_path__ + "018958ca0c6f70c579e26a48416c9b83.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/clever-share-settings.png
// module id = 1028
// module chunks = 0